import request from './request'
import { useSystemInfo } from '@/store'
// 查询域名配置
export const domainConfigList = (params: any) =>
  request({
    url: '/carbon-misc/public/domain/list',
    method: 'GET',
    params,
  })

// 查询宝箱活动配置 登录
export const configDetailById = (params: any) =>
  request({
    url: '/carbon-promotion/private/user/activity/treasure/box/homepage',
    method: 'GET',
    params,
  })

// 查询宝箱活动配置 未登录
export const configDetailByIdWithoutAuth = (params: any) =>
  request({
    url: '/carbon-promotion/public/activity/treasure/box/homepage',
    method: 'GET',
    params,
  })

// 领取宝箱
export const receiveTreaturebox = (params: any) =>
  request({
    url: '/operation/activity/treasurebox/receive',
    method: 'POST',
    params,
  })

// 查询宝箱活动直推用户列表
export const queryTreatureboxInvitationsList = (params: any) =>
  request({
    url: '/carbon-promotion/private/user/activity/treasure/box/invitations',
    method: 'GET',
    params,
  })

// 查询宝箱活动条件
export const queryTreatureboxCondition = (params: any) =>
  request({
    url: '/carbon-promotion/public/activity/treasure/box/condition',
    method: 'GET',
    params,
  })

// 获取宝箱分享配置文字
export const getTreasureboxShareConfig = () =>
  request({
    url: '/carbon-misc/public/web/config/sharing/config',
    method: 'GET',
    params: {
      language: useSystemInfo().language,
    },
  })
